import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api, assetUrl } from "@/lib/api";

const META = {
  zabavne: { title: "Zábavné světy", desc: "Svatební weby s filmovou a pohádkovou tematikou – od Středozemě po předalekou galaxii." },
  klasicke: { title: "Klasické světy", desc: "Elegantní, čisté a nadčasové svatební weby bez filmové tematiky." },
};

export default function WorldsCategory() {
  const { kategorie } = useParams();
  const [worlds, setWorlds] = useState([]);
  const meta = META[kategorie] || META.zabavne;

  useEffect(() => {
    document.title = `${meta.title} | Svatební světy`;
    api.listWorlds().then((r) => setWorlds(r.data.filter((w) => (w.category || "zabavne") === kategorie))).catch(() => {});
  }, [kategorie, meta.title]);

  return (
    <div className="min-h-screen bg-[#0B0908] text-[#F2EAD9]">
      <nav className="fixed top-0 z-40 flex w-full items-center justify-between border-b border-[#2E271C] bg-[#0B0908]/85 px-6 py-4 backdrop-blur-xl">
        <Link to="/" data-testid="category-back-btn" className="flex items-center gap-2 rounded-full border border-[#2E271C] px-4 py-2 text-sm text-[#F2EAD9]/80 transition-colors hover:border-[#C9A961] hover:text-[#C9A961]">
          <ArrowLeft size={16} /> Zpět na hlavní stránku
        </Link>
        <a href="/#objednat" className="rounded-full bg-[#C9A961] px-5 py-2 text-sm font-medium text-[#0B0908] hover:bg-[#DEC182]">
          Objednej web
        </a>
      </nav>

      <div className="mx-auto max-w-6xl px-6 pb-24 pt-32">
        <p className="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-[#C9A961]">Kategorie</p>
        <h1 className="font-heading text-4xl sm:text-5xl">{meta.title}</h1>
        <p className="mt-3 max-w-xl text-[#9C917E]">{meta.desc}</p>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3" data-testid="worlds-grid">
          {worlds.map((w, i) => {
            const cat = w.catalog || {};
            return (
              <motion.div key={w.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.1 }}>
                <Link
                  to={`/svet/${w.slug}`}
                  data-testid={`world-card-${w.slug}`}
                  className="group block overflow-hidden rounded-2xl border border-[#2E271C] bg-[#141109] transition-all duration-300 hover:-translate-y-2 hover:border-[#C9A961]/70 hover:shadow-[0_20px_60px_rgba(0,0,0,.6),0_0_30px_rgba(201,169,97,.15)]"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img src={assetUrl(cat.preview_image || w.preview_image)} alt={cat.name || w.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" style={{ backgroundColor: w.theme?.bg }} />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#141109] via-black/20 to-transparent" />
                    <div className="absolute bottom-4 left-5 right-5">
                      <h3 className="font-heading text-2xl text-[#F2EAD9]">{cat.name || w.name}</h3>
                      <p className="text-sm text-[#F2EAD9]/60">{cat.tagline ?? w.tagline}</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between px-5 py-4">
                    <span className="text-xs uppercase tracking-[0.2em] text-[#9C917E]">{cat.welcome_title || w.welcome_title}</span>
                    <span className="flex items-center gap-1 text-sm text-[#C9A961] transition-transform group-hover:translate-x-1">
                      Náhled <ArrowRight size={16} />
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
